export const SET_TEMPLATE_LIST = 'SET_TEMPLATE_LIST'
export const SET_STAFF_LIST = 'SET_STAFF_LIST'
